<i18n>
{
"en": {
  "ALERT": "Alert",
  "SESSIONHASBEENEXPIRED": "You have been logged out. Session has been expired!!",
  "SESSIONABOUTTOEXPIRESOON": "Session about to expire soon!",
  "CANCEL": "Cancel",
  "CONFIRM": "Confirm", 
  "PLEASEENTERYOURPASSWORD": "Please enter your password",
  "REQUIREDAUTHENTICATION": "Authentication required!",
  "AUTHENTICATING": "Authenticating...",
  "INVALIDUSER": "Invalid user",
  "ISREQUIRED": "is required."
},
"ar": {
  "ALERT": "تحذير ",
  "SESSIONHASBEENEXPIRED": "لقد تم تسجيل الخروج. انتهت صلاحية الدورة!!",
  "SESSIONABOUTTOEXPIRESOON": "دورة على وشك الانتهاء قريبا!",
  "CANCEL": "إلغاء",
  "CONFIRM": "تاكيد ",
  "PLEASEENTERYOURPASSWORD": " من فضلك أدخل رقمك السري",
  "REQUIREDAUTHENTICATION": "مطلوب المصادقة!",
  "AUTHENTICATING": "...مصادقة ",
  "INVALIDUSER": "المستخدم غير صالح",
  "ISREQUIRED": ".مطلوب"
}
}
</i18n>
<template>
    <el-dialog
        v-if="sessionDialog"
        :title="$t('ALERT')"
        :visible.sync="sessionDialog"
        size="tiny"
        :close-on-click-modal="false"
        :show-close="false">
        <b v-if="sessionExpiration == null">{{$t('SESSIONHASBEENEXPIRED')}}</b>
        <el-form v-if="sessionExpiration != null" :model="session" :rules="rules" ref="session" label-width="100px" label-position="top">
            <el-form-item :label="$t(message)" prop="pass">
                <el-input type="password" :placeholder="$t('PLEASEENTERYOURPASSWORD')" @keyup.enter.native="submitForm()" v-model="session.pass"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="danger" icon="time"  v-if="showTimer()">{{timer}}</el-button>
            <el-button @click="sessionDialog = false">{{$t('CANCEL')}}</el-button>
            <el-button type="primary" @click="submitForm" v-if="sessionExpiration != null" :loading="loading">{{loading ? $t('AUTHENTICATING') : $t('CONFIRM')}}</el-button>    
        </span>
    </el-dialog> 
</template>

<script>
  let userData = null
  
  import _ from 'lodash'
  import { EventBus } from '../../event-bus.js'
  export default {
    name: 'ElAuthDialog',
    componentName: 'ElAuthDialog',
    props: {
      sessionExpiration: {
        type: Number,
        default: 0
      },
      visible: {
        type: Boolean,
        default: false
      },
      message: {
        type: String,
        default: 'SESSIONABOUTTOEXPIRESOON'
      },
      timer: {
        type: String,
        default: null
      },
      configuration: {
        type: Object,
        default: function () {
          return {}
        }
      },
      itSelf: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      sessionDialog () {
        this.$emit('update:visible', this.sessionDialog)
      },
      visible () {
        this.switchLanguage()
        userData = JSON.parse(localStorage.getItem('userData'))
        this.sessionDialog = this.visible
      }
    },
    data () {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('ISREQUIRED')))
        }
        callback()
      }
      return {
        rules: {pass: {validator: validatePass, trigger: 'blur'}},
        session: {pass: ''},
        sessionDialog: false,
        loading: false
      }
    },
    updated () {
    },
    methods: {
      submitForm () {
        let self = this
        this.$refs.session.validate((valid) => {
          if (valid) return self.extendSession()
          return false
        })
      },
      showTimer () {
        if (!this.itSelf) return false
        if (this.sessionExpiration === null) return false
        return true
      },
      extendSession () {
        let data = userData
        let postData = !_.isEmpty(this.configuration) ? {user: {username: data.username, password: this.session.pass, school: data.school_access, lang: localStorage.getItem('lang')}} : {username: data.username, password: this.session.pass, school: data.school_access, lang: localStorage.getItem('lang')}
        if (!_.isEmpty(this.configuration)) postData.configuration = this.configuration
        let self = this
        self.loading = true
        let endpoint = 'auth'
        if (!this.itSelf) endpoint = self.$route.path.split('/')[2] + '/save'
        this.$http.post('/' + endpoint, postData).then(function (response) {
          self.loading = false
          if (_.has(response.data, 'user_data')) {
            if (response.data.error) return self.$message({type: 'warning', message: self.$t(response.data.message)})
            userData = response.data.user_data
            let locale = {'country': userData.school_location.country, 'timeZone': 'N/A'}
            localStorage.setItem('lang', userData.lang)
            localStorage.setItem('locale', JSON.stringify(locale))
            EventBus.$emit('userData', userData)
          }
          self.$emit('authBack', response.data)
          self.session.pass = null
          self.sessionDialog = false
        }).catch(function (response) {})
      }
    }
}
</script>



// WEBPACK FOOTER //
// Auth.vue?c0bdc48a